import { RefinementListItem } from 'src/types'

export default (item: RefinementListItem) => item.isRefined
